import {
  ActionType,
  ChallengesType,
  ErrorTypes,
  LoadingStatusType,
  ChallengeResultOrderType,
  ChallengeTypeType,
} from 'interfaces';
import { historySelectedChallengeType } from 'reducers/challenge.reducer';
import { TCurrentGlobalViewWidgetSet } from 'interfaces/widgets.types';
import {
  action,
  createRequestTypes,
  FAILURE,
  REQUEST,
  RequestTypes,
  SUCCESS,
} from 'services/api';
import { GetProductsParams } from 'services/product.api';

export const USER_CHALLENGES: RequestTypes =
  createRequestTypes('USER_CHALLENGES');

export const SET_USER_CHALLENGES_LOADING_STATUS =
  'SET_USER_CHALLENGES_LOADING_STATUS';
export const USER_CHALLENGE_DECLARATIONS = createRequestTypes(
  'USER_CHALLENGE_DECLARATIONS',
);
export const SET_SELECTED_CHALLENGE_DATA_ACTION = createRequestTypes(
  'SET_SELECTED_CHALLENGE_DATA_ACTION',
);
export const SET_LOADING_SELECTED_CHALLENGE_DATA_ACTION =
  'SET_LOADING_SELECTED_CHALLENGE_DATA_ACTION';
export const USER_CHALLENGE: RequestTypes =
  createRequestTypes('USER_CHALLENGE');
export const USER_CHALLENGE_DECLARATION_REQUEST =
  'USER_CHALLENGE_DECLARATION_REQUEST';
export const TOTAL_USER_PARTICIPATION: RequestTypes = createRequestTypes(
  'TOTAL_USER_PARTICIPATION',
);
export const POST_USER_PARTICIPATION: RequestTypes = createRequestTypes(
  'POST_USER_PARTICIPATION',
);
export const CHALLENGE_RESULTS: RequestTypes =
  createRequestTypes('CHALLENGE_RESULTS');
export const CHALLENGE_RANKS: RequestTypes =
  createRequestTypes('CHALLENGE_RANKS');
export const POST_USER_CHALLENGE_PHOTO_RESULTS: RequestTypes =
  createRequestTypes('POST_USER_CHALLENGE_PHOTO_RESULTS');
export const SET_CHALLENGE_LOADING_STATUS = 'SET_CHALLENGE_LOADING_STATUS';
export const SET_CHALLENGE_RESULTS_STATUS = 'SET_CHALLENGE_RESULTS_STATUS';
export const SET_CHALLENGE_RANKS_LOADING = 'SET_CHALLENGE_RANKS_LOADING';
export const CHALLENGE_RESULT_VOTE: RequestTypes = createRequestTypes(
  'CHALLENGE_RESULT_VOTE',
);
export const CHALLENGE_RESULT_UNVOTE: RequestTypes = createRequestTypes(
  'CHALLENGE_RESULT_UNVOTE',
);
export const SET_CHALLENGE_RESULT_VOTING_STATUS =
  'SET_CHALLENGE_RESULT_VOTING_STATUS';
export const CHALLENGE_PRODUCTS: RequestTypes =
  createRequestTypes('CHALLENGE_PRODUCTS');

export const userChallenges = {
  request: (): ActionType => action(USER_CHALLENGES[REQUEST]),
  success: ({ data }: { data: unknown }): ActionType =>
    action(USER_CHALLENGES[SUCCESS], { data }),
  failure: ({ error }: { error: ErrorTypes }): ActionType =>
    action(USER_CHALLENGES[FAILURE], { error }),
};

export const setSelectedChallengeDataAction = {
  request: ({
    selectedChallengeId,
    isMobile,
  }: {
    selectedChallengeId: undefined | string;
    isMobile: boolean;
  }): ActionType =>
    action(SET_SELECTED_CHALLENGE_DATA_ACTION[REQUEST], {
      selectedChallengeId,
      isMobile,
    }),
  success: ({
    historySelectedChallenge,
  }: {
    historySelectedChallenge: historySelectedChallengeType;
  }): ActionType =>
    action(SET_SELECTED_CHALLENGE_DATA_ACTION[SUCCESS], {
      historySelectedChallenge,
    }),
  failure: ({ error }: { error: ErrorTypes }): ActionType =>
    action(SET_SELECTED_CHALLENGE_DATA_ACTION[FAILURE], { error }),
};

export const setLoadingSelectedChallengeDataAction = (
  status: LoadingStatusType,
): ActionType => action(SET_LOADING_SELECTED_CHALLENGE_DATA_ACTION, { status });

export const setUserChallengesLoadingStatus = (
  status: LoadingStatusType,
): ActionType => action(SET_USER_CHALLENGES_LOADING_STATUS, { status });

export const userChallenge = {
  request: ({ challengeId }: { challengeId: number }): ActionType =>
    action(USER_CHALLENGE[REQUEST], { challengeId }),
  success: ({
    challengeId,
    data,
  }: {
    challengeId: number;
    data: unknown;
  }): ActionType => action(USER_CHALLENGE[SUCCESS], { challengeId, data }),
  failure: ({
    challengeId,
    error,
  }: {
    challengeId: string | number;
    error: ErrorTypes;
  }): ActionType => action(USER_CHALLENGE[FAILURE], { challengeId, error }),
};

export const userChallengeDeclarations = {
  request: ({
    challengeId,
  }: {
    challengeId: number | string | undefined;
  }): ActionType =>
    action(USER_CHALLENGE_DECLARATIONS[REQUEST], { challengeId }),
  success: ({
    challengeId,
    data,
  }: {
    challengeId: number;
    data: unknown;
  }): ActionType =>
    action(USER_CHALLENGE_DECLARATIONS[SUCCESS], { challengeId, data }),
  failure: ({
    challengeId,
    error,
  }: {
    challengeId: string | number;
    error: ErrorTypes;
  }): ActionType =>
    action(USER_CHALLENGE_DECLARATIONS[FAILURE], { challengeId, error }),
};

export const userChallengeDeclaration = {
  request: ({ challengeId }: { challengeId: number }): ActionType =>
    action(USER_CHALLENGE_DECLARATION_REQUEST, { challengeId }),
};

export const getTotalUsersParticipation = {
  request: ({ challenge }: { challenge: ChallengesType }): ActionType =>
    action(TOTAL_USER_PARTICIPATION[REQUEST], { challenge }),
  success: ({
    challengeId,
    totalParticipatingUsers,
  }: {
    challengeId: number;
    totalParticipatingUsers: number;
  }): ActionType =>
    action(TOTAL_USER_PARTICIPATION[SUCCESS], {
      challengeId,
      totalParticipatingUsers,
    }),
  failure: ({
    challengeId,
    error,
  }: {
    challengeId: string | number;
    error: ErrorTypes;
  }): ActionType =>
    action(TOTAL_USER_PARTICIPATION[FAILURE], { challengeId, error }),
};

export const postUserParticipation = {
  request: ({
    challengeId,
    isParticipating,
    contentId,
    currentGlobalViewWidgetSet,
  }: {
    challengeId: number;
    isParticipating: boolean;
    contentId: number | undefined;
    currentGlobalViewWidgetSet?: TCurrentGlobalViewWidgetSet;
  }): ActionType =>
    action(POST_USER_PARTICIPATION[REQUEST], {
      challengeId,
      isParticipating,
      contentId,
      currentGlobalViewWidgetSet,
    }),
  success: ({
    challengeId,
    data,
  }: {
    challengeId: number;
    data: ChallengesType;
  }): ActionType =>
    action(POST_USER_PARTICIPATION[SUCCESS], { challengeId, data }),
  failure: ({
    challengeId,
    error,
  }: {
    challengeId: string | number;
    error: ErrorTypes;
  }): ActionType =>
    action(POST_USER_PARTICIPATION[FAILURE], { challengeId, error }),
};

export const setChallengeLoadingStatus = (
  challengeId: string,
  status: LoadingStatusType,
): ActionType => action(SET_CHALLENGE_LOADING_STATUS, { challengeId, status });

export const challengeResults = {
  request: ({
    challengeId,
    page = 1,
    order = 'asc',
    challengeType,
    all = false,
  }: {
    challengeId: number;
    page?: number;
    order?: ChallengeResultOrderType;
    challengeType?: ChallengeTypeType;
    all?: boolean;
  }): ActionType =>
    action(CHALLENGE_RESULTS[REQUEST], {
      challengeId,
      page,
      order,
      challengeType,
      all,
    }),
  success: ({
    challengeId,
    data,
    page,
    totalItems,
    isWaitingModeration,
  }: {
    challengeId: number;
    data: unknown;
    page: number;
    totalItems: number;
    isWaitingModeration: boolean;
  }): ActionType =>
    action(CHALLENGE_RESULTS[SUCCESS], {
      challengeId,
      data,
      page,
      totalItems,
      isWaitingModeration,
    }),
  failure: ({
    challengeId,
    error,
  }: {
    challengeId: string | number;
    error: ErrorTypes;
  }): ActionType => action(CHALLENGE_RESULTS[FAILURE], { challengeId, error }),
};

export const setChallengeResultsStatus = (
  challengeId: number,
  status: LoadingStatusType,
  isFirstCall: boolean | null,
): ActionType =>
  action(SET_CHALLENGE_RESULTS_STATUS, { challengeId, status, isFirstCall });

export const challengeRanks = {
  request: ({ challengeId }: { challengeId: number }): ActionType =>
    action(CHALLENGE_RANKS[REQUEST], { challengeId }),
  success: ({
    challengeId,
    data,
  }: {
    challengeId: number;
    data: unknown;
  }): ActionType => action(CHALLENGE_RANKS[SUCCESS], { challengeId, data }),
  failure: ({
    challengeId,
    error,
  }: {
    challengeId: string | number;
    error: ErrorTypes;
  }): ActionType => action(CHALLENGE_RANKS[FAILURE], { challengeId, error }),
};

export const setChallengeRanksLoading = (isLoading: boolean): ActionType =>
  action(SET_CHALLENGE_RANKS_LOADING, { isLoading });

export const postUserChallengePhotoResults = {
  request: ({
    challengeId,
    photo,
    status,
    resultId,
  }: {
    challengeId: number;
    photo: File;
    status: string | undefined;
    resultId: number | undefined;
  }): ActionType =>
    action(POST_USER_CHALLENGE_PHOTO_RESULTS[REQUEST], {
      challengeId,
      photo,
      status,
      resultId,
    }),
  success: ({
    challengeId,
    data,
  }: {
    challengeId: number;
    data: unknown;
  }): ActionType =>
    action(POST_USER_CHALLENGE_PHOTO_RESULTS[SUCCESS], { challengeId, data }),
  failure: ({
    challengeId,
    error,
  }: {
    challengeId: string | number;
    error: ErrorTypes;
  }): ActionType =>
    action(POST_USER_CHALLENGE_PHOTO_RESULTS[FAILURE], { challengeId, error }),
};

export const challengeResultVote = {
  request: (resultId: number, callback?: () => void): ActionType =>
    action(CHALLENGE_RESULT_VOTE[REQUEST], { resultId, callback }),
  success: ({
    resultId,
    data,
  }: {
    resultId: number;
    data: unknown;
  }): ActionType => action(CHALLENGE_RESULT_VOTE[SUCCESS], { resultId, data }),
  failure: ({
    resultId,
    error,
  }: {
    resultId: number;
    error: ErrorTypes;
  }): ActionType => action(CHALLENGE_RESULT_VOTE[FAILURE], { resultId, error }),
};

export const challengeResultUnvote = {
  request: (resultId: number, callback?: () => void): ActionType =>
    action(CHALLENGE_RESULT_UNVOTE[REQUEST], { resultId, callback }),
  success: ({
    resultId,
    data,
  }: {
    resultId: number;
    data: unknown;
  }): ActionType =>
    action(CHALLENGE_RESULT_UNVOTE[SUCCESS], { resultId, data }),
  failure: ({
    resultId,
    error,
  }: {
    resultId: string | number;
    error: ErrorTypes;
  }): ActionType =>
    action(CHALLENGE_RESULT_UNVOTE[FAILURE], { resultId, error }),
};

export const setChallengeResultVotingStatus = (
  resultId: number,
  status: LoadingStatusType,
): ActionType =>
  action(SET_CHALLENGE_RESULT_VOTING_STATUS, { resultId, status });

export const challengeProducts = {
  request: (filters: GetProductsParams): ActionType =>
    action(CHALLENGE_PRODUCTS[REQUEST], { filters }),
  success: ({
    challengeId,
    data,
  }: {
    challengeId: number;
    data: unknown;
  }): ActionType => action(CHALLENGE_PRODUCTS[SUCCESS], { challengeId, data }),
  failure: ({
    challengeId,
    error,
  }: {
    challengeId: string | number;
    error: ErrorTypes;
  }): ActionType => action(CHALLENGE_PRODUCTS[FAILURE], { challengeId, error }),
};
